import { parseQueryString, colorLuminance, importScript, initPopupAsset } from '../../../webroot/media/scripts/shared'
/* TODO: need to remove Ractive library */
import Ractive from '../../../webroot/media/scripts/modules/ractive'
import { prepareSearchResponseProducts } from '../../utils/productsHelper'
import { IS_MOZ_BROWSER } from '../../Constants/global'

// eslint-disable-next-line import/no-webpack-loader-syntax
require('imports-loader?jQuery=jquery!../../../webroot/media/scripts/modules/rater.min.js')

const spiral = window.spiral
const portalDomain = window.portalDomain

export default class Widgets {
  static run (options) {
    return new Widgets(options)
  }

  constructor (options) {
    const lib = options.lib

    this.$widgets = $('.widget-products')
    this.$widgetSliders = $('.widget-products-slider')
    this.$widgetsProduct = $('.widget-products-block')
    const isWindows = navigator.appVersion.includes('Win') ? 'win' : ''
    const isMoz = IS_MOZ_BROWSER ? 'moz' : ''

    if (this.$widgets.length) {
      const Items = Ractive.extend({ template: '#tpl-items' })

      Ractive.components.items = Items
      const tpl = Ractive.parse('{{>tpl-widget-new-popular}}')

      this.$widgets.each(function () {
        const $t = $(this)
        const data = $t.data()
        const library = data.library
        const categories = data.categories ? data.categories.replace(' ', '-') : null
        let url = `/search?library=${library}`

        if (categories) { url += `&categories=${categories}` }

        if (data.query) { url += `&query=${data.query}` }

        if (data.exclude) { url += `&exclude=${data.exclude}` }

        const rv = new Ractive({
          el: this,
          template: tpl,
          data: {
            url,
            name: data.name,
            library,
            query: data.query,
            categories,
            formatDuration (dur) {
              const s = dur % 60

              return `${Math.floor(dur / 60)}:${s < 10 ? '0' : ''}${s}`
            },
          },
          components: { items: Items },
        })
        const sendData = {
          limit: 3,
          library,
          cache: true,
          sortBy: 'newest',
        }

        if (categories) { sendData.categories = categories }

        if (data.query) { sendData.query = data.query }

        if (data.exclude) { sendData.exclude = data.exclude }

        spiral.ajax({
          url: '/search/findProducts',
          data: sendData,
          processAnswer (answer) {
            rv.set('productsNewest', prepareSearchResponseProducts(answer.response.products))
          },
        })
        sendData.sortBy = 'popular'
        spiral.ajax({
          url: '/search/findProducts',
          data: sendData,
          processAnswer (answer) {
            rv.set('productsPopular', prepareSearchResponseProducts(answer.response.products))
          },
        })
        $t.addClass('product-line')
      })
      setTimeout(this.productsHoverListener, 200)
    }

    if (this.$widgetSliders.length) {
      const loadSlides = (sendData, rv) => {
        spiral.ajax({
          url: '/search/findProducts',
          data: sendData,
          processAnswer (answer) {
            if (answer.response.status !== 200 || !answer.response.pagination.total) {
              $(rv.el).closest('section').hide()

              return
            }

            if (sendData.offset && sendData.offset >= sendData.limit) {
              rv.push('slides', prepareSearchResponseProducts(answer.response.products))
            } else {
              const slide1 = []
              const slide2 = []

              prepareSearchResponseProducts(answer.response.products).forEach((p, i) => {
                (i < sendData.limit / 2) ? slide1.push(p) : slide2.push(p)
              })
              rv.push('slides', slide1)
              rv.push('slides', slide2)
              sendData.cache = false
              sendData.limit = sendData.limit / 2
            }

            rv.set('total', answer.response.pagination.total)
          },
        })
      }

      const tpl = Ractive.parse('{{>tpl-slider}}')
      let widgetCounter = 1

      this.$widgetSliders.each(function () {
        const $t = $(this)
        const data = $t.data()
        const sliderType = data.type
        const isCaptivate = data.captivate || false
        const bgColor = data.color || '#000'
        const classColor = `widget-color-${bgColor.replace('#', '')}`
        const itemsAmount = sliderType === 'new' ? 6 : 4

        const rv = new Ractive({
          el: this,
          template: tpl,
          data: {
            ie8: Boolean(lib.ie8),
            widgetNumber: widgetCounter,
            isWindows,
            isMoz,
            slides: [],
            currentSlide: 0,
            total: 0,
            sliderType,
            classColor,
            portalDomain,
            color: bgColor,
            isCaptivate,
            borderColor: data.borderColor || colorLuminance(bgColor, 0.1),
            nameBackgroundColor: data.nameBackgroundColor || bgColor,
            hoverText: data.hoverText,
            formatDuration (dur) {
              const s = dur % 60

              return `${Math.floor(dur / 60)}:${s < 10 ? '0' : ''}${s}`
            },
            getExtention (str) {
              return (str.split('.').length > 1) ? str.split('.').pop() : ''
            },
          },
        })

        widgetCounter++
        const productsData = window[data.products]
        let sendData = {}

        if (productsData) {
          for (let i = 0, j = productsData.length; i < j; i += itemsAmount) {
            rv.push('slides', productsData.slice(i, i + itemsAmount))
          }

          rv.set('total', productsData.length)
        } else {
          const queryData = parseQueryString(data.query)

          // first we load 8 products (2 slides), then 4 (1 slide)
          sendData = {
            limit: sliderType === 'new' ? 12 : 8,
            cache: true,
            offset: 0,
          }
          sendData = spiral.tools.extend(sendData, queryData)
          loadSlides(sendData, rv)
        }

        let localMaxSlide = 1

        $t.addClass(`slider-part ${classColor} ${sliderType ? `widget-products-slider-${sliderType}` : ''}`)

        rv.on('slide', (rev, dir) => {
          rv.add('currentSlide', dir)
          if (!productsData) {
            const c = rv.get('currentSlide')

            if (c >= localMaxSlide) {
              localMaxSlide = c
              sendData.offset = localMaxSlide * (itemsAmount) + (itemsAmount)
              loadSlides(sendData, rv)
            }
          }
        })
      })
      this.$widgetSliders.on('mouseover', '.item', function () {
        const t = this
        const $t = $(t)
        const $popup = $t.find('.product-popup')

        if (!$popup.length) { return }

        const $rate = $popup.find('.stars')
        const $rated = $rate.find('.rate-base-layer').length

        if (!$rated) {
          const options = {
            symbols: {
              utf8_star: {
                base: '\u2605',
                hover: '\u2605',
                selected: '\u2605',
              },
            },
            max_value: 5,
            step_size: 0.5,
            readonly: true,
            selected_symbol_type: 'utf8_star',
          }

          $rate.rate(options)
        }
      })
    }

    if (this.$widgetsProduct.length) {
      const tpl = Ractive.parse('{{>tpl-widget-products-block}}')

      this.$widgetsProduct.each(function () {
        const $t = $(this)
        const data = $t.data()

        const rv = new Ractive({
          el: this,
          template: tpl,
          data: {
            name: data.name,
            products: [],
            formatDuration (dur) {
              const s = dur % 60

              return `${Math.floor(dur / 60)}:${s < 10 ? '0' : ''}${s}`
            },
          },
        })

        const queryData = parseQueryString(data.query)

        let sendData = { limit: 8, cache: true, offset: 0 }

        sendData = spiral.tools.extend(sendData, queryData)

        spiral.ajax({
          url: '/search/findProducts',
          data: sendData,
          processAnswer (answer) {
            rv.set('products', prepareSearchResponseProducts(answer.response.products))
          },
        })

        $t.addClass('library-part')
      })
    }
  }

  productsHoverListener () {
    const lib = window.lib

    if (!lib.ie8) {
      if (lib.awesomium) {
        importScript('/media/scripts/modules/flowplayer-3.2.13.min.js')
      } else {
        importScript('/media/scripts/modules/video.novtt.js')
      }
    }

    lib.videos = {}
    lib.vidid = 1
    lib.audios = {}
    lib.audid = 1

    $('.line.media-line').on('mouseover', '.item', function () {
      const t = this
      const $t = $(t)

      if ($t.hasClass('hovered')) { return }

      $t.addClass('hovered')
      initPopupAsset(t)
    }).on('mouseleave', '.item', function () {
      const t = this
      const $t = $(t)

      $t.removeClass('hovered')
      switch ($t.data('type')) {
        case 'audioBlocks':
          lib.audios[`aud_${$t.data('audid')}`].stop()
          $t.find('.overlay').css('width', 0)
          break
        case 'videoBlocks':
          if (lib.videos[`vid_${$t.data('vidid')}`]) { lib.videos[`vid_${$t.data('vidid')}`].pause() }

          break
        default:
          break
      }
    })
  }
}
